import { render, staticRenderFns } from "./organisationApplicationSummary.vue?vue&type=template&id=476d18f1&"
import script from "./organisationApplicationSummary.vue?vue&type=script&lang=js&"
export * from "./organisationApplicationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports